export enum StatusCodes {
  OK = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  PreconditionFailed = 412,
  InternalServer = 500,
  GatewayTimeout = 504,
}
